// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn genDocRefEligibleEntityTypes.
//
// This file is generated from:
// - Constraint definitions in packages/building-types/doc/docEntityConstraints.ts
import type { DocEntityType } from "building-types/doc/docEntityTypes";

/**
 * Runtime object for doc entity types that should traverse reverse references when being imported from a doc ref.
 */
export const docRefReverseTraversalTargetEntities = {
  LABEL: true,
} as const satisfies Partial<Record<DocEntityType, true>>;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn genDocRefEligibleEntityTypes.
//
// This file is generated from:
// - Constraint definitions in packages/building-types/doc/docEntityConstraints.ts
